// if max is an integer then returns random in the range [0, max-1]
import { Random } from 'reliable-random';
let generator;
export function randomInt(max) {
    if (generator == null) {
        generator = new Random(0, 0);
    }
    return generator.randint(max);
}
export function initRandom(seed) {
    generator = new Random(seed, 0);
}
export function random() {
    if (generator == null) {
        generator = new Random(0, 0);
    }
    return generator.random();
}
//# sourceMappingURL=random.js.map